// Distinct overlapping real records need distinct visual rows.
export function layoutOwnerTodayTracks(items=[],maxRows=6) {
 const rows=[],overflow=[];
 const sorted=items.filter(item=>Number.isFinite(new Date(item.startAt).getTime())&&Number.isFinite(new Date(item.endAt).getTime())&&new Date(item.endAt)>new Date(item.startAt))
   .slice().sort((a,b)=>new Date(a.startAt)-new Date(b.startAt)||new Date(b.endAt)-new Date(a.endAt));
 for(const item of sorted){const a=new Date(item.startAt).getTime(),b=new Date(item.endAt).getTime();
  let index=rows.findIndex(row=>row.lastEnd<=a);
  if(index<0){if(rows.length>=maxRows){overflow.push(item);continue;}index=rows.length;rows.push({lastEnd:0,items:[]});}
  rows[index].items.push(item);rows[index].lastEnd=b;
 }
 return {tracks:rows.map(r=>r.items),overflow};
}
